<div class="container animated fadeInRight">
  <app-lfsa-card [innTemplate]="Administrador" [titulo]="'Datos Administrador'" [efecto]="true"
    [colapseName]="'administrador'" [banderaColapse]='true'></app-lfsa-card>
  <ng-template #Administrador>
    <div class="row col-12">
      <div class="col-md-6">
        <h5><b>Nombres :</b>&nbsp;{{ dataUsuario.nombre }}</h5>
      </div>
      <div class="col-md-6">
        <h5><b>Apellidos :</b>&nbsp;{{  dataUsuario.apellido }}</h5>
      </div>
      <hr>
    </div>
  </ng-template>

  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/empresas'] " class="btn btn-primary btn-block btn-lg ">CREAR EMPRESAS</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/cargos'] " class="btn btn-primary btn-block btn-lg ">CARGOS</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/empleados'] " class="btn btn-primary btn-block btn-lg ">NUEVO / MODIFICAR USUARIO</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/upload-emp'] " class="btn btn-primary btn-block btn-lg ">CSV EMPLEADO</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/eliminar-empleado'] " class="btn btn-primary btn-block btn-lg ">ELIMINAR EMPLEADO</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/crear-historial'] " class="btn btn-primary btn-block btn-lg ">CREAR HISTORIAL</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/control-empresa'] " class="btn btn-primary btn-block btn-lg ">CONTROL POR EMPRESA</button>
    </div>
  </div> 
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/reporte-horas'] " class="btn btn-primary btn-block btn-lg ">REPORTE HORAS</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/reporte'] " class="btn btn-primary btn-block btn-lg ">REPORTE HISTORICO</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/reporte-emp'] " class="btn btn-primary btn-block btn-lg ">REPORTE DE EMPLEADOS</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/desvinculacion-contratista'] " class="btn btn-primary btn-block btn-lg ">DESVINCULAR CONTRATISTA/PROVEEDOR</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/matn-marcacion'] " class="btn btn-primary btn-block btn-lg ">MANTENER REGISTROS DE COLABORADORES</button>
    </div>
  </div>
  <br>
</div>